import { __rest as e } from "tslib";
import * as r from "react";
import t from "classnames";
import { classNameModifier as n } from "../shared/utils.js";
import { ComponentClassNames as o } from "../shared/constants.js";
import { Flex as a } from "../Flex/Flex.js";
import { View as i } from "../View/View.js";
var l = r.forwardRef(function (l, m) {
  var s = l.children,
      p = l.className,
      d = l.innerEndComponent,
      u = l.innerStartComponent,
      _l$orientation = l.orientation,
      c = _l$orientation === void 0 ? "horizontal" : _l$orientation,
      F = l.outerEndComponent,
      E = l.outerStartComponent,
      G = l.variation,
      f = e(l, ["children", "className", "innerEndComponent", "innerStartComponent", "orientation", "outerEndComponent", "outerStartComponent", "variation"]);
  var N = null != d,
      C = null != u ? o.FieldGroupHasInnerStart : null,
      S = N ? o.FieldGroupHasInnerEnd : null,
      h = t(o.FieldGroup, C, S, n(o.FieldGroup, c), p);
  return r.createElement(a, Object.assign({
    className: h,
    "data-orientation": c,
    ref: m
  }, f), E && r.createElement(i, {
    className: t(o.FieldGroupOuterStart, n(o.FieldGroupOuterStart, G))
  }, E), r.createElement(i, {
    className: t(o.FieldGroupFieldWrapper, n(o.FieldGroupFieldWrapper, c)),
    "data-orientation": c
  }, u && r.createElement(i, {
    className: o.FieldGroupInnerStart
  }, u), s, d && r.createElement(i, {
    className: o.FieldGroupInnerEnd
  }, d)), F && r.createElement(i, {
    className: t(o.FieldGroupOuterEnd, n(o.FieldGroupOuterEnd, G))
  }, F));
});
l.displayName = "FieldGroup";
export { l as FieldGroup };